/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArtificialIntelligence = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2a8.001 8.001 0 0 1 7.938 7H22v2l-2.062.001a7.985 7.985 0 0 1-2.657 5.008A4.998 4.998 0 0 1 22 21v1H2v-1a5 5 0 0 1 4.719-4.992A7.977 7.977 0 0 1 4.062 11H2V9h2.062A8.001 8.001 0 0 1 12 2zm5 16H7c-1.302 0-2.41.83-2.825 1.988L4.17 20h15.659l-.076-.193a3.002 3.002 0 0 0-2.577-1.802zM12 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm-2 4v4H8V8zm6 0v4h-2V8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgArtificialIntelligence as ArtificialIntelligence };
